import { render, staticRenderFns } from "./CreateTableView.vue?vue&type=template&id=093c5750&scoped=true"
import script from "./CreateTableView.vue?vue&type=script&lang=js"
export * from "./CreateTableView.vue?vue&type=script&lang=js"
import style0 from "./CreateTableView.vue?vue&type=style&index=0&id=093c5750&prod&lang=scss"
import style1 from "./CreateTableView.vue?vue&type=style&index=1&id=093c5750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "093c5750",
  null
  
)

export default component.exports